import { Burger, Grid, Group } from "@mantine/core";
import { useGetEmailByIndividualIdQuery } from '../../../app/api/usersApiHandler';
import { useGetClientByIdQuery } from '../../../app/api/projectsApiHandler';
// import PinionLogo from "../../../assets/images/logo/PinionLogo.png";
import PinionWhite from "../../../assets/images/logo/logo-white.png";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../routes/paths";
// import CustomDivider from "../../../components/ui/CustomDivider/CustomDivider";
import UserMenu from "./UserMenu";
import { navBarTextColor } from "../../../components/mantineReactTable/sizes";
import type { UsersRoles } from "../../../types/users";


interface HeaderProps {
  mobileOpened: boolean | undefined;
  desktopOpened: boolean | undefined;
  toggleMobile: () => void;
  toggleDesktop: () => void;
  isEnable?: boolean;
  isMobile?: boolean;
  isEnableToolBar?: boolean;
  canAccessMyProfile?: boolean;
  roleDefinitions?: UsersRoles[];
}
const Header = ({ mobileOpened, toggleMobile, desktopOpened, toggleDesktop, isMobile, isEnableToolBar, canAccessMyProfile, roleDefinitions }: HeaderProps) => {
  const emailId = sessionStorage.getItem('LoggedUserEmail');
  const { data: UsersData } = useGetEmailByIndividualIdQuery({
    primaryEmail: emailId,
  });
  const { data: organizationData } = useGetClientByIdQuery({
    ClientId: UsersData?.data[0]?.organizationId ? UsersData?.data[0]?.organizationId : "00000000-0000-0000-0000-000000000000"
  })

  const navigate = useNavigate();
  const navigateToHomePage = () => {
    navigate(ROUTES.home);
  }

  // const computedColorScheme = useComputedColorScheme('light', { getInitialValueInEffect: true });
  // const image = computedColorScheme === 'dark' ? PinionWhite : PinionLogo;

  return (
    <>
      <Grid justify="space-between" align="flex-start" mb={15}>
          <Grid.Col span={{ base: 6, md: 6, lg: isMobile ? 6 : 12 }} >
            <Group pl={"xs"} >
              <Burger
                opened={mobileOpened}
                onClick={toggleMobile}
                hiddenFrom="sm"
                size="xs"
                color={navBarTextColor}
                style={{ marginTop: `${organizationData?.data?.organizationLogo ? '10px' : '25px'}` }}
              />
              <Burger
                opened={desktopOpened}
                onClick={toggleDesktop}
                visibleFrom="sm"
                size="xs"
                color={navBarTextColor}

                style={{ marginTop: `${organizationData?.data?.organizationLogo ? '10px' : '25px'}` }}
              />
              {(desktopOpened || isEnableToolBar) && (<img
                src={organizationData?.data?.organizationLogo || PinionWhite}
                className="respLogo"
                alt="Pinion"
                onClick={navigateToHomePage}
                height={40}
                style={{ marginTop: '10px', cursor: 'pointer' }}
              />)}
            </Group>
            {/* <CustomDivider /> */}
          </Grid.Col>
          {isMobile && <Grid.Col span={{ base: 6, md: 6, lg: isMobile ? 6 : 12 }} mt={10}>
            <UserMenu isEnableIconOnly={true} canAccessMyProfile={canAccessMyProfile} roleDefinitions={roleDefinitions} />
          </Grid.Col>}
        </Grid>

    </>
  );
};
export default Header;